// config
import { appConfig } from '../../../../config/app-config';

// own feature
import { UiMessageSnackType } from '../model/message-snack.types';

export class UiMessageSnack {

   constructor(
       public message: string,
       public module: string,
       public type: UiMessageSnackType,
       public duration = appConfig.app.errMsgDurationToShow
   ) {
      // case sussess -> have less duration to show message
      if (type === 'SUCCESS') {
         this.duration = appConfig.app.successMsgDurationToShow;
      }
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/components/message-snack/model/message-snack.class.ts